export enum EntityGroupEnum {
  SALE_AND_LEASE_BACK_TYPE_ID = 'vehicles.saleLeaseBack',
}
